import { render, staticRenderFns } from "./RealVsAuditChart.vue?vue&type=template&id=06654116&scoped=true"
import script from "./RealVsAuditChart.vue?vue&type=script&lang=js"
export * from "./RealVsAuditChart.vue?vue&type=script&lang=js"
import style0 from "./RealVsAuditChart.vue?vue&type=style&index=0&id=06654116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06654116",
  null
  
)

export default component.exports